import React from 'react';
import {Link} from 'react-router-dom';
import logo from '../images/new_logo.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin, faFacebook, faAngellist, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import logo_yellow_two from '../images/new_logo.svg';
import GeneralContactForm from './GeneralContactForm';

export default class Footer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
    }
  }

  render() {


    return (
      <div className="footer">
        <div className="actionable-links">
          <div className="links">
            <div className="us-info">
              <div className="desc">
                <h2>Prosession Homes</h2>

                <br />

                <div className="text">
                  Number one in real estate for 25 years.
                </div>

                <Link className="main-logo" to="/">
                  <img className="logo" src={logo_yellow_two} alt="Logo"/>
                </Link>
              </div>
            </div>

            <GeneralContactForm />
          </div>
        </div>
      </div>
    )
  }
};
